import { getPageUrl as activityFeed } from 'src/app/[locale]/(activity-feed)/fundraising-events/[slug]/manage/live-widgets/activity-feed/paths'
import { getPageUrl as donate } from 'src/app/[locale]/(public)/donate/[channel]/[receiver-type]/[slug]/paths'
import { getPageUrl as error403 } from 'src/app/[locale]/403/paths'
import { getPageUrl as fonts } from 'src/app/api/fonts/paths'
import { getPageUrl as fundraisingEventForwarding } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/forwarding/paths'
import { getPageUrl as fundraisingEventPublicPage } from 'src/app/[locale]/(standard)/(receiver-page)/fundraising-events/[slug]/paths'
import { getPageUrl as fundraisingEventThankYou } from 'src/app/[locale]/(public)/fundraising-events/[slug]/thank-you/paths'
import { getPageUrl as fundraisingEventThankYouModal } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/@modal/(..)thank-you/paths'
import { getPageUrl as iframeDonate } from 'src/app/[locale]/(public)/donate/iframe/[receiver-type]/[slug]/paths'
import {
  getWidgetModalUrl as liveWidgetsConfig,
  getPageUrl as liveWidgetsOverview,
} from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/paths'
import { getPageUrl as liveWidgetsDonationAlert } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/donation-alert/paths'
import { getPageUrl as liveWidgetsLastComment } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/last-comment/paths'
import { getPageUrl as liveWidgetsProgress } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/progress/paths'
import { getPageUrl as liveWidgetsProjectLogos } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/project-logos/paths'
import { getPageUrl as liveWidgetsStandard } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/standard/paths'
import { getPageUrl as liveWidgetsTopDonation } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/top-donation/paths'
import { getPageUrl as liveWidgetsTopDonor } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/top-donor/paths'
import { getPageUrl as liveWidgetsTotal } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/total/paths'
import { getPageUrl as liveWidgetsVoting } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/voting/paths'
import { getPageUrl as liveWidgetsWebhook } from 'src/app/[locale]/(standard)/(manage)/fundraising-events/[slug]/manage/live-widgets/@widgets/webhook/paths'
import { getPageUrl as livez } from 'src/app/api/livez/paths'
import { getPageUrl as streambotVoting } from 'src/app/[locale]/(public)/streambot/fundraising-events/[slug]/voting/paths'
import { getPageUrl as streambotWidget } from 'src/app/[locale]/(public)/streambot/fundraising-events/[slug]/[widget]/paths'
import { getPageUrl as widgetSettings } from 'src/app/api/widget-settings/[slug]/paths'
import { getPageUrl as widgetSettingsWithQuestion } from 'src/app/api/widget-settings/with-question/[slug]/paths'

const Routes = {
  activityFeed,
  donate,
  error403,
  fundraisingEventPublicPage,
  fundraisingEventThankYou,
  fundraisingEventForwarding,
  iframeDonate,
  liveWidgetsConfig,
  liveWidgetsOverview,
  liveWidgetsTopDonation,
  liveWidgetsTopDonor,
  liveWidgetsTotal,
  liveWidgetsWebhook,
  liveWidgetsDonationAlert,
  liveWidgetsVoting,
  liveWidgetsLastComment,
  liveWidgetsProgress,
  liveWidgetsProjectLogos,
  liveWidgetsStandard,
  streambotVoting,
  streambotWidget,
  fundraisingEventThankYouModal,
  api: {
    fonts,
    livez,
    widgetSettings,
    widgetSettingsWithQuestion,
  },
} as const

export default Routes
